/**
 * Webfont Loader to improve performance
 * @url https://github.com/typekit/webfontloader
 */

import WebFont from 'webfontloader'

WebFont.load({
  google: {
    families: ['Playfair Display:400,400i']
  }
});
